import { createContextStore } from "../helpers/createContext";
import { useContext } from "react";

export const DarkModeContext = createContextStore(false);
export const useUpdateDarkMode = () => useContext(DarkModeContext.DispatchContext);
export const useDarkMode = () => useContext(DarkModeContext.State);